module.exports = __webpack_public_path__ + "img/scientific-research.51807c72.png";